import t from "../../../../../helpers/t";
import React, { useEffect, useState } from "react";
import { in_array } from "../../../../../../utils/Helper";
import { membershipTypeActions, useSelector } from "inbooma-api";
import { Biscuit } from "../../../../../../utils";

const MembershipsSelect = (props) => {
  const { user, dispatch } = props;
  const _membershipTypes = useSelector((state) => state.membership_types_data.membershipTypes);
  const [membershipTypesResults, setMembershipTypesResults] = useState([]);
  const [membershipTypesResultsHidden, setMembershipTypesResultsHidden] = useState(true);
  const [membershipTypesPending, setMembershipTypesPending] = useState(false);

  useEffect(() => {
    if (_membershipTypes.success === "" && !membershipTypesPending) {
      dispatch(
        membershipTypeActions.getMembershipTypes({
          token: Biscuit.get("token"),
          filter: {
            limit: "999",
            sort: "name",
            sortDirection: "asc",
          },
        }),
      );
      setMembershipTypesPending(true);
    }
  }, []);
  useEffect(() => {
    if (_membershipTypes.success === "" || !membershipTypesPending) return;
    if (_membershipTypes.success === true) {
      let contain = [];
      for (let e = 0; e < _membershipTypes.data.length; e++) {
        if (in_array(_membershipTypes.data[e].id, contain)) {
          delete _membershipTypes.data[e];
          continue;
        }
        contain.push(_membershipTypes.data[e].id);
      }
      setMembershipTypesResults([..._membershipTypes.data]);
    }
    setMembershipTypesPending(false);
  }, [_membershipTypes]);
  const onMembershipTypeSearchChanged = (e) => {
    const value = e.target.value;
    let results = [];
    if (value.length == 0) {
      setMembershipTypesResults([..._membershipTypes.data]);
    } else {
      results = [];
      // search for locations with name starting with query (value)
      for (var i = 0; i < _membershipTypes.data.length; i++) {
        if (_membershipTypes.data[i].name.toLowerCase().startsWith(value))
          results.push(_membershipTypes.data[i]);
      }
      setMembershipTypesResults(results);
    }
  };

  const onMembershipTypesSelectHandle = (e, membershipType) => {
    // add selection to array if not already selected
    if (!e.target.parentNode.classList.contains("selected")) {
      user.memberships.push({
        membership_type_id: membershipType.id,
        name: membershipType.name,
      });
    }
  };

  const onMembershipTypeSearchBlur = (e) => {
    setTimeout(() => {
      setMembershipTypesResultsHidden(true);
      document.getElementsByClassName("select2-search__field2")[0].value = "";
    }, 200);
  };

  const onMembershipTypeSearchClicked = (e) => {
    document.getElementsByClassName("select2-search__field2")[0].style.width = "9em";
    document.getElementsByClassName("select2-search__field2")[0].focus();
    setMembershipTypesResults([..._membershipTypes.data]);
    setMembershipTypesResultsHidden(false);
  };

  const isMembershipTypeSelected = (id) => {
    for (let i = 0; i < user.memberships.length; i++) {
      if (user.memberships[i].membership_type_id === id) return true;
    }
    return false;
  };
  const getMembershipTypeById = (id) => {
    if (typeof _membershipTypes.data === "undefined" || _membershipTypes.data == null) return "";

    for (let i = 0; i < _membershipTypes.data.length; i++) {
      if (_membershipTypes.data[i].id === id) return _membershipTypes.data[i].name;
    }
    return "";
  };

  const onMembershipTypeRemove = (e, membershipType, index) => {
    user.memberships.splice(index, 1);
  };

  return (
    <>
      <div className="inb-form-group column medium-12 small-12 _backform_userfroups">
        <label className="inb-form__controlLabel">{t("usergroups", null, "capital")}</label>
        <div className="inb-form__controllClass">
          <span
            className="select2 select2-container select2-container--default select2-container--focus"
            dir="ltr"
            data-select2-id="2"
            style={{ width: "auto" }}
          >
            <span className="selection">
              <span
                className="select2-selection select2-selection--multiple"
                role="combobox"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex="-1"
              >
                <ul className="select2-selection__rendered" onClick={onMembershipTypeSearchClicked}>
                  {user.memberships.map((membership, index) => {
                    if (typeof membership.membership_type_id !== "undefined") {
                      return (
                        <>
                          <li className="select2-selection__choice" title={membership.name}>
                            <span
                              className="select2-selection__choice__remove"
                              role="presentation"
                              onClick={(e) => {
                                onMembershipTypeRemove(e, membership, index);
                              }}
                            >
                              ×
                            </span>
                            {membership.name}
                          </li>
                        </>
                      );
                    }
                  })}

                  <li
                    className="select2-search select2-search--inline"
                    style={{ paddingTop: "5px" }}
                  >
                    <input
                      className="select2-search__field2"
                      type="search"
                      tabIndex="0"
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="none"
                      spellCheck="false"
                      role="textbox"
                      aria-autocomplete="list"
                      placeholder={t("switch")}
                      onChange={onMembershipTypeSearchChanged}
                      onBlur={onMembershipTypeSearchBlur}
                    />
                  </li>
                </ul>
              </span>
            </span>
            <ul
              className={
                "inbooma-select-box-results" +
                (membershipTypesResultsHidden === true ? " hide" : "")
              }
              style={{ width: "100%" }}
            >
              {membershipTypesResults.map((membershipType) => {
                return (
                  <li
                    className={
                      "inbooma-select-box-results__field" +
                      (isMembershipTypeSelected(membershipType.id) ? " selected" : "")
                    }
                    key={membershipType.id}
                    value={membershipType.id}
                    onClick={(e) => {
                      onMembershipTypesSelectHandle(e, membershipType);
                    }}
                  >
                    <span style={{ width: "100%" }}>{membershipType.name}</span>
                  </li>
                );
              })}
            </ul>
          </span>
        </div>
      </div>
    </>
  );
};

export default MembershipsSelect;
